<template lang="">
  <v-card color="basil">
    <v-toolbar :color="background" flat height="120">
      <v-img :src="getLogo()" contain height="100px"></v-img>
    </v-toolbar>

    <v-tabs
      v-model="tab"
      background-color="transparent"
      grow
      @change="handleTabChange"
    >
      <v-tab v-for="item in items" :key="item.name">
        {{ item.name }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item v-for="item in items" :key="item.name">
        <component :is="item.component" />
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>
<script>
import DefaultLayout from "@/components/layouts/DefaultLayout.vue";
import { mapState } from "vuex";

export default {
  name: "ConfigView",
  components: {
    ConfigGeneral: () =>
      import("@/components/real-estate-group/config/index.vue"),
    ConfigWebhooks: () =>
      import("@/components/real-estate-group/config/webhooks/index.vue")
  },
  data() {
    return {
      background: "blue-grey lighten-4",
      tab: null,
      items: [
        {
          name: "General",
          route: "general",
          component: "ConfigGeneral"
        },
        {
          name: "Webhooks",
          route: "webhooks",
          component: "ConfigWebhooks"
        }
      ]
    };
  },
  created() {
    this.$emit(`update:layout`, DefaultLayout);
  },
  computed: {
    ...mapState("realEstateGroup", {
      inmo: state => state.realEstateGroup,
      loading: state => state.realEstateGroupLoading
    })
  },
  watch: {
    "$route.params.tab": {
      handler(newTab) {
        const tabIndex = this.items.findIndex(item => item.route === newTab);
        if (tabIndex !== -1 && tabIndex !== this.tab) {
          this.tab = tabIndex;
        }
      },
      immediate: true
    }
  },
  methods: {
    getLogo() {
      if (this.inmo?.media?.logo?.src) {
        return this.inmo.media.logo.src;
      }
      const localStorageLogo = localStorage.getItem("real_estate_group_logo");
      if (
        localStorageLogo &&
        localStorageLogo !== "undefined" &&
        localStorageLogo !== ""
      ) {
        return localStorageLogo;
      }

      return require("@/assets/logoC28_primary.png");
    },
    handleTabChange(index) {
      const selectedItem = this.items[index];
      this.$router.push({
        name: this.$route.name,
        params: {
          id: this.$route.params.id,
          tab: selectedItem.route
        }
      });
    },
    initializeTabFromRoute() {
      const currentTab = this.$route.params.tab;
      const tabIndex = this.items.findIndex(item => item.route === currentTab);
      if (tabIndex !== -1) {
        this.tab = tabIndex;
      } else {
        // Si no hay tab en la URL, redirigir al primer tab
        this.$router.replace({
          name: this.$route.name,
          params: {
            id: this.$route.params.id,
            tab: this.items[0].route
          }
        });
      }
    }
  }
};
</script>
